import { createSelector } from 'reselect';

import { selectViolationStateMap } from '@/features/violations/selectViolationStateMap';

export const selectViolations = (id: string) =>
  createSelector([selectViolationStateMap], (violationStateMap) => violationStateMap[id]);
